<template>
    <LayoutBase>
        <div class="print_page container">
            <slot></slot>
        </div>
    </LayoutBase>
</template>

<script>
import LayoutBase from "../base/LayoutBase.vue";

export default {
  name: "LayoutPrintPage",
  components: {LayoutBase},
  mounted() {
    // This is here so that html, body, and #app don't have height set via css
    const root = document.documentElement
    root.classList.remove('layout_page')
  },
}
</script>

<style lang="scss" scoped>
@media screen {
  .print_page {
    padding: 2rem 1rem;
  }
}
</style>
